import { useQuery } from '@tanstack/react-query';
import { getPolicySettings } from '@/backend/services/policySettings';

export function usePolicySettings() {
  return useQuery({
    queryKey: ['policy-settings'],
    queryFn: getPolicySettings,
    staleTime: 5 * 60 * 1000,
  });
}
